"use client";

import { FC } from "react";
import Skeleton from "@mui/material/Skeleton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";

import useExploreSearch from "@/hooks/useExploreSearch";
import Masonry, { ResponsiveMasonry } from "@/components/layout/masonry";
import FeedCard from "@/components/feed/FeedCard";

interface RelatedGensProps {
  searchQuery: string;
  breakpoints?: { [bp: number]: number };
}

const RelatedGens: FC<RelatedGensProps> = ({
  searchQuery,
  breakpoints = {
    350: 2,
    800: 3,
    1000: 4,
    1200: 5,
    1500: 6,
    1900: 7,
  },
}) => {
  const { loading, searchResults } = useExploreSearch(searchQuery, true);

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <ResponsiveMasonry columnsCountBreakpoints={breakpoints}>
      <Masonry gutter="0.5em">
        {loading &&
          [...new Array(isMobile ? 6 : 20)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              height={200}
              style={{ borderRadius: "15px" }}
            />
          ))}
        {searchResults.map((item, index) => {
          return (
            <FeedCard
              key={`search-card-${index + 1}`}
              item={item}
              hideUserDetails
            />
          );
        })}
      </Masonry>
    </ResponsiveMasonry>
  );
};

export default RelatedGens;
